<template>
    <d-card class="h-100">
        <d-card-header :class="{ 'border-bottom success': facebook }" class="border-bottom">Facebook</d-card-header>
        <d-card-body>
            <d-col class="d-flex justify-content-center">
                <img class="img-fluid" src="@/assets/images/facebook.png" alt="facebook">
            </d-col>
        </d-card-body>
        <d-col class="mb-3" v-if="create == true">
            <facebook-update-connection-form v-if="isUpdate" :website-id="websiteId" :configuration="facebook" />
            <facebook-connect-form v-else :website-id="websiteId" />
        </d-col>
        <d-card-footer v-else class="d-flex justify-content-center">
            <button v-if="facebook" @click="showFacebookForm" class="btn btn-secondary">Connected</button>
            <button v-else @click="showFacebookForm" class="btn btn-success">Connect</button>
        </d-card-footer>
    </d-card>
</template>

<script>
    import FacebookConnectForm from '@/views/integrations/facebook/ConnectForm'
    import FacebookUpdateConnectionForm from '@/views/integrations/facebook/UpdateConnectionForm'

    export default {
        props: ['facebook'],

        components: {
            FacebookConnectForm,
            FacebookUpdateConnectionForm,
        },

        data() {
            return {
                create: false,
                isUpdate: false,
                websiteId: this.$route.params.id
            };
        },

        methods: {
            showFacebookForm() {
                this.create = true
            },
        },

        created() {
            this.isUpdate = !!this.facebook
        },

        beforeUpdate() {
            if (! this.isUpdate) {
                this.isUpdate = !!this.facebook // for already storing show update form
            }
        }
    };
</script>